import React, { useEffect } from "react";
import { Box, Button, IconButton, InputBase, Pagination } from "@mui/material";
import { AdminButton, TableMui } from "../../components/mui";
import { Search } from "@mui/icons-material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useNavigate } from "react-router-dom";
export default () => {
  const navigate = useNavigate();
  const data = [
    {
      sr: "1",
      type: "video",
      description: "A video of a cat playing with a toy",
      date: "2022-04-20",
      time: "13:30:00",
      sent_by: "Usman",
      approve: "approved",
      approve_by: "Jack Reborn",
    },
    {
      sr: "2",
      type: "photo",
      description: "A photo of a mountain landscape",
      sent_by: "Usman",
      approve: "approved",
      date: "2022-04-21",
      approve_by: "Mia Adams",
      time: "10:45:00",
    },
    {
      sr: "3",
      type: "drone",
      description: "A drone video of a city skyline",
      date: "2022-04-22",
      time: "15:20:00",
      sent_by: "Usman",
      approve: "approved",
      approve_by: "Jack Reborn",
    },
    {
      sr: "4",
      type: "video",
      description: "A video of a dog chasing a ball",
      date: "2022-04-23",
      time: "09:15:00",
      sent_by: "Usman",
      approve: "denied",
      approve_by: "",
    },
    {
      sr: "5",
      type: "photo",
      description: "A photo of a beach at sunset",
      date: "2022-04-24",
      time: "18:30:00",
      sent_by: "Usman",
      approve: "approved",
      approve_by: "Jack Reborn",
    },
    {
      sr: "6",
      type: "drone",
      description: "A drone video of a forest",
      date: "2022-04-25",
      time: "12:00:00",
      sent_by: "Usman",
      approve: "approved",
      approve_by: "Mia Adams",
    },
    {
      sr: "7",
      type: "video",
      description: "A video of a bird singing",
      date: "2022-04-26",
      time: "08:45:00",
      sent_by: "waqas",
      approve: "denied",
      approve_by: "",
    },
    {
      sr: "8",
      type: "photo",
      description: "A photo of a waterfall",
      date: "2022-04-27",
      time: "16:15:00",
      sent_by: "Usman",
      approve: "denied",
      approve_by: "",
    },
    {
      sr: "9",
      type: "drone",
      description: "A drone video of a river",
      date: "2022-04-28",
      time: "14:00:00",
      sent_by: "ali",
      approve: "approved",
      approve_by: "hassan",
    },
  ];

  useEffect(() => {
    document.title = "RollingAdz: Requests" || "Default Title";
  }, []);

  return (
    <>
      <div className="container d-flex justify-content-between">
        <div
          className=" d-flex justify-content-between align-items-center px-4 col-md-6"
          style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
        >
          <InputBase
            className=""
            sx={{
              ml: 1,
              flex: 1,
              px: 1,
            }}
            placeholder="Search..."
            type="search"
          />
          <Box
            sx={{
              width: "25px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 1,
            }}
          >
            <IconButton
              type="button"
              sx={{
                p: "5px",
                backgroundColor: "#3E4755",
                color: "white",
                "&:hover": {
                  backgroundColor: "#3E4755",
                  color: "white",
                },
              }}
              aria-label="search"
            >
              <Search style={{ fontSize: 25 }} />
            </IconButton>
          </Box>
        </div>
        <div>
          <AdminButton
            onClick={() => {
              navigate("/admin/add-request");
            }}
            name="Add New"
          />
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <h1 style={{ color: "black" }}> Requests</h1>
      </div>
      <div>
        <TableMui
          styleTableTh={{
            color: "#black",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
          th={{
            sr: (
              <>
                Sr: <FilterAltOutlinedIcon />
              </>
            ),
            type: (
              <>
                Request Type <FilterAltOutlinedIcon />
              </>
            ),
            description: (
              <>
                Description <FilterAltOutlinedIcon />
              </>
            ),
            sent_by: (
              <>
                Sent By <FilterAltOutlinedIcon />
              </>
            ),
            approve: (
              <>
                Approve/Deny <FilterAltOutlinedIcon />
              </>
            ),
            approve_by: (
              <>
                Approve By <FilterAltOutlinedIcon />
              </>
            ),
            date: (
              <>
                Date <FilterAltOutlinedIcon />
              </>
            ),
            time: (
              <>
                Time <FilterAltOutlinedIcon />
              </>
            ),
          }}
          td={data}
        />
      </div>
      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
      </div>
    </>
  );
};
